import MasterLayout from "../masterLayout/MasterLayout";
import { FeaturedMediaListLayer } from "../components/featuredMedia/FeaturedMediaListLayer";

export const FeaturedMediaPage = () => {
  return (
    <MasterLayout>
      <FeaturedMediaListLayer />
    </MasterLayout>
  );
};
